<div class="page-container">
  <div class="aspect-h-2 aspect-w-6 lg:aspect-h-1 lg:aspect-w-4">
    <div
      class="absolute inset-0 flex items-center justify-center bg-neutral-900 bg-cover bg-center bg-no-repeat"
      style="background-image: url('/assets/img/blog-header-bg.svg')"
    >
      <h1
        class="mb-0 text-5xl font-bold uppercase tracking-widest text-white md:text-7xl lg:text-8xl"
      >
        Blog
      </h1>
    </div>
  </div>

  <div class="h-14 border-b">
    <div *ngIf="category || tag" class="flex items-center">
      <div>
        <a
          [routerLink]="['/blog']"
          [queryParams]="queryParamsWithout('categories')"
          class="inline-flex items-center gap-2 p-4 font-medium"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4"
            viewBox="0 0 512 512"
          >
            <path
              fill="none"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="48"
              d="M328 112L184 256l144 144"
            />
          </svg>
          <span class="align-middle">All Posts</span>
        </a>
      </div>

      <div *ngIf="category">
        <a
          [routerLink]="category.route"
          [queryParams]="queryParamsMerge(category.routeQueryParams)"
          class="inline-block p-4 font-medium"
        >
          Category: {{ category.name }}
        </a>
      </div>
      <div *ngIf="tag">
        <a
          [routerLink]="tag.route"
          [queryParams]="queryParamsMerge(tag.routeQueryParams)"
          class="inline-block p-4 font-medium"
        >
          Tag: {{ tag.name }}
        </a>
      </div>
    </div>

    <div
      *ngIf="!category && !tag && categories?.length"
      class="flex flex-nowrap justify-center overflow-x-auto"
    >
      <div *ngFor="let category of categories" class="shrink-0">
        <a
          [routerLink]="category.route"
          [queryParams]="queryParamsMerge(category.routeQueryParams)"
          class="inline-block p-4 font-medium"
        >
          {{ category.name }}
        </a>
      </div>
    </div>
  </div>

  <div class="pb-24 pt-12">
    <div class="blog-post-container container mx-auto max-w-4xl">
      <div class="px-4">
        <div class="" [hidden]="loading || posts.length">
          <h2>No posts here yet...</h2>
        </div>

        <div *ngIf="loading" class="py-12">
          <div
            class="text-center"
            appLoader
            [loading]="true"
            loaderColor="dark"
            [loaderWidth]="50"
          ></div>
        </div>

        <div *ngIf="author" class="mb-8 text-center text-xl">
          <a
            class="text-neutral-600 hover:text-neutral-800"
            [routerLink]="['.']"
          >
            Posts by {{ author.name }}
          </a>
        </div>

        <div class="space-y-12" [hidden]="loading">
          <a
            *ngFor="let post of posts"
            class="block overflow-hidden rounded-xl border bg-white shadow-sm hover:bg-gray-50"
            [routerLink]="post.route"
          >
            <div class="flex flex-col sm:flex-row sm:items-stretch">
              <div
                *ngIf="post.featured_image"
                class="aspect-h-9 aspect-w-16 shrink-0 bg-gray-50 sm:aspect-h-2 sm:aspect-w-6 sm:w-1/3 sm:border-r md:w-1/2"
              >
                <img
                  class="h-full w-full object-cover sm:h-full sm:w-full"
                  [src]="
                    post.featured_image?.media_details?.sizes?.large?.source_url
                  "
                  alt="{{ post.title?.rendered }}"
                />
              </div>

              <div class="flex flex-col justify-center p-8">
                <h2
                  class="text-2xl leading-normal text-black"
                  [innerHTML]="post.title.rendered | appSafeHtml"
                ></h2>

                <div
                  *ngIf="post.excerpt?.rendered"
                  class="mt-2 line-clamp-3 text-black"
                  [innerHTML]="post.excerpt.rendered | appSafeHtml"
                ></div>
              </div>
            </div>
          </a>
        </div>
      </div>

      <div class="mt-8 px-4">
        <div class="">
          <div class="flex justify-between">
            <div>
              <app-button
                *ngIf="pageInfo?.hasPrevPage"
                color="primary"
                fill="outline"
                [route]="['.']"
                [queryParams]="{ page: +pageInfo?.currentPage - 1 }"
              >
                <i class="app-icon-chevron-left align-middle"></i> Prev
              </app-button>
            </div>

            <div>
              <app-button
                *ngIf="pageInfo?.hasNextPage"
                color="primary"
                fill="outline"
                [route]="['.']"
                [queryParams]="{ page: +pageInfo?.currentPage + 1 }"
              >
                Next <i class="app-icon-chevron-right align-middle"></i>
              </app-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
